import type { TranslationMessages } from "ra-core";

// [hiperautomacao] Brazilian Portuguese for the react-admin core and the
// Supabase auth screens. Keys missing here fall back to English.
export const portugueseRaMessages: TranslationMessages = {
  ra: {
    action: {
      add_filter: "Filtrar",
      add: "Adicionar",
      back: "Voltar",
      bulk_actions: "1 item selecionado |||| %{smart_count} itens selecionados",
      cancel: "Cancelar",
      clear_array_input: "Limpar a lista",
      clear_input_value: "Limpar",
      clone: "Duplicar",
      confirm: "Confirmar",
      create: "Criar",
      create_item: "Criar %{item}",
      delete: "Apagar",
      edit: "Editar",
      export: "Exportar",
      list: "Lista",
      refresh: "Atualizar",
      remove_filter: "Tirar este filtro",
      remove_all_filters: "Tirar todos os filtros",
      remove: "Remover",
      reset: "Limpar",
      save: "Salvar",
      search: "Buscar",
      search_columns: "Buscar colunas",
      select_all: "Selecionar tudo",
      select_all_button: "Selecionar tudo",
      select_row: "Selecionar esta linha",
      show: "Ver",
      sort: "Ordenar",
      undo: "Desfazer",
      unselect: "Desmarcar",
      expand: "Expandir",
      close: "Fechar",
      open_menu: "Abrir menu",
      close_menu: "Fechar menu",
      update: "Atualizar",
      move_up: "Subir",
      move_down: "Descer",
      open: "Abrir",
      toggle_theme: "Alternar claro/escuro",
      select_columns: "Colunas",
      update_application: "Recarregar o aplicativo",
    },
    boolean: {
      true: "Sim",
      false: "Não",
      null: " ",
    },
    page: {
      create: "Criar %{name}",
      dashboard: "Painel",
      edit: "%{name} %{recordRepresentation}",
      error: "Algo deu errado",
      list: "%{name}",
      loading: "Carregando",
      not_found: "Não encontrado",
      show: "%{name} %{recordRepresentation}",
      empty: "Ainda não há %{name}.",
      invite: "Quer adicionar um?",
      access_denied: "Acesso negado",
      authentication_error: "Erro de autenticação",
    },
    input: {
      file: {
        upload_several: "Solte arquivos aqui ou clique para escolher.",
        upload_single: "Solte um arquivo aqui ou clique para escolher.",
      },
      image: {
        upload_several: "Solte imagens aqui ou clique para escolher.",
        upload_single: "Solte uma imagem aqui ou clique para escolher.",
      },
      references: {
        all_missing: "Não foi possível encontrar os dados relacionados.",
        many_missing:
          "Pelo menos uma das referências não está mais disponível.",
        single_missing: "A referência não está mais disponível.",
      },
      password: {
        toggle_visible: "Esconder senha",
        toggle_hidden: "Mostrar senha",
      },
    },
    message: {
      about: "Sobre",
      access_denied: "Você não tem permissão para acessar esta página",
      are_you_sure: "Tem certeza?",
      authentication_error:
        "O servidor de autenticação respondeu com erro e não foi possível conferir o seu acesso.",
      auth_error: "Erro ao validar o seu acesso.",
      bulk_delete_content:
        "Apagar este %{name}? |||| Apagar estes %{smart_count} itens?",
      bulk_delete_title: "Apagar %{name} |||| Apagar %{smart_count} %{name}",
      bulk_update_content:
        "Atualizar %{name} %{recordRepresentation}? |||| Atualizar estes %{smart_count} itens?",
      bulk_update_title:
        "Atualizar %{name} %{recordRepresentation} |||| Atualizar %{smart_count} %{name}",
      clear_array_input: "Limpar a lista inteira?",
      delete_content: "Apagar este %{name}?",
      delete_title: "Apagar %{name} %{recordRepresentation}",
      details: "Detalhes",
      error: "Algo deu errado e o pedido não foi concluído.",
      invalid_form: "O formulário tem erros. Confira os campos.",
      loading: "Aguarde",
      no: "Não",
      not_found: "Endereço errado ou link quebrado.",
      select_all_limit_reached:
        "São itens demais para selecionar todos. Só os primeiros %{max} foram selecionados.",
      unsaved_changes: "Há alterações não salvas. Sair mesmo assim?",
      yes: "Sim",
      placeholder_data_warning: "Problema de rede: não foi possível atualizar.",
    },
    navigation: {
      clear_filters: "Limpar filtros",
      no_filtered_results: "Nenhum %{name} com estes filtros.",
      no_results: "Nenhum %{name} encontrado",
      no_more_results: "A página %{page} não existe. Tente a anterior.",
      page_out_of_boundaries: "A página %{page} não existe",
      page_out_from_end: "Esta é a última página",
      page_out_from_begin: "Esta é a primeira página",
      page_range_info: "%{offsetBegin}-%{offsetEnd} de %{total}",
      partial_page_range_info:
        "%{offsetBegin}-%{offsetEnd} de mais de %{offsetEnd}",
      current_page: "Página %{page}",
      page: "Ir para a página %{page}",
      first: "Primeira página",
      last: "Última página",
      next: "Próxima página",
      previous: "Página anterior",
      page_rows_per_page: "Linhas por página:",
      skip_nav: "Ir para o conteúdo",
    },
    sort: {
      sort_by: "Ordenar por %{field_lower_first} %{order}",
      ASC: "crescente",
      DESC: "decrescente",
    },
    auth: {
      auth_check_error: "Entre para continuar",
      user_menu: "Perfil",
      username: "Usuário",
      password: "Senha",
      email: "E-mail",
      sign_in: "Entrar",
      sign_in_error: "Não foi possível entrar. Tente de novo",
      logout: "Sair",
    },
    notification: {
      updated: "Atualizado |||| %{smart_count} itens atualizados",
      created: "Criado",
      deleted: "Apagado |||| %{smart_count} itens apagados",
      bad_item: "Item incorreto",
      item_doesnt_exist: "O item não existe",
      http_error: "Erro de comunicação com o servidor",
      data_provider_error:
        "Erro ao falar com o banco. Veja os detalhes no console.",
      i18n_error: "Não foi possível carregar o idioma",
      canceled: "Ação cancelada",
      logged_out: "A sua sessão terminou. Entre de novo.",
      not_authorized: "Você não tem permissão para isto.",
      application_update_available: "Há uma versão nova.",
      offline: "Sem conexão. Não foi possível buscar os dados.",
    },
    validation: {
      required: "Obrigatório",
      minLength: "Pelo menos %{min} caracteres",
      maxLength: "No máximo %{max} caracteres",
      minValue: "No mínimo %{min}",
      maxValue: "No máximo %{max}",
      number: "Precisa ser um número",
      email: "Precisa ser um e-mail válido",
      oneOf: "Precisa ser um destes: %{options}",
      regex: "Formato inválido: %{pattern}",
      unique: "Já existe",
    },
    saved_queries: {
      label: "Buscas salvas",
      query_name: "Nome da busca",
      new_label: "Salvar esta busca...",
      new_dialog_title: "Salvar esta busca como",
      remove_label: "Apagar busca salva",
      remove_label_with_name: 'Apagar a busca "%{name}"',
      remove_dialog_title: "Apagar a busca salva?",
      remove_message: "Tirar este item das buscas salvas?",
      help: "Filtre a lista e salve a busca para depois",
    },
    guesser: {
      empty: {
        title: "Nada para mostrar",
        message: "Confira a conexão com os dados",
      },
    },
    configurable: {
      customize: "Personalizar",
      configureMode: "Configurar esta página",
      inspector: {
        title: "Inspetor",
        content: "Passe o mouse nos elementos para configurá-los",
        reset: "Voltar ao padrão",
        hideAll: "Esconder tudo",
        showAll: "Mostrar tudo",
      },
      Datagrid: {
        title: "Tabela",
        unlabeled: "Coluna sem nome #%{column}",
      },
      SimpleForm: {
        title: "Formulário",
        unlabeled: "Campo sem nome #%{input}",
      },
      SimpleList: {
        title: "Lista",
        primaryText: "Texto principal",
        secondaryText: "Texto secundário",
        tertiaryText: "Texto terciário",
      },
    },
  },
  "ra-supabase": {
    auth: {
      email: "E-mail",
      confirm_password: "Confirme a senha",
      sign_in_with: "Entrar com %{provider}",
      forgot_password: "Esqueceu a senha?",
      reset_password: "Redefinir senha",
      password_reset:
        "Veja no seu e-mail a mensagem para criar uma nova senha.",
      missing_tokens: "O link de acesso e o de renovação estão faltando",
      back_to_login: "Voltar para entrar",
    },
    reset_password: {
      forgot_password: "Esqueceu a senha?",
      forgot_password_details:
        "Digite o seu e-mail para receber as instruções.",
    },
    set_password: {
      new_password: "Escolha a nova senha",
    },
    validation: {
      password_mismatch: "As senhas não conferem",
    },
  },
};
